import { Link } from 'react-router-dom';



const AdvantagesBox = (): JSX.Element => {

	return (
		<div className='advantages-box'>
				
			<p>Jsou také skvělým řešením pro psí alergiky, kterým brání v&nbsp;kontaktu s&nbsp;postiženou kůží. VETlímce šijeme z&nbsp;odolné, omyvatelné textilie se&nbsp;specifickými vlastnostmi (tzv.&nbsp;kočárkoviny). Ta&nbsp;je velmi praktická na&nbsp;údržbu -&nbsp;při běžném znečistění límec stačí pouze otřít. VETlímec tak&nbsp;může vašemu psovi sloužit dlouhodobě, třeba i&nbsp;celý život.</p>
			
			<p className='link-text'>{'Máte doma náš produkt a\u00a0ztratili jste návod k použití? Nezoufejte a\u00a0stáhněte si jej '}
				<Link to={'https://vetlimce.blob.core.windows.net/vcz/Navod-k-pouziti-pes-limec.pdf'} className='disable-selection' target='_blank'>
					ZDE
				</Link>.
			</p>
		
		</div>
	);
};

export default AdvantagesBox;